import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {DropdownOptions} from "../dropdown-options";

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html'
})
export class MultiselectDropdownComponent implements OnInit, OnChanges {
  @Input() msSettings = DropdownOptions.getMsSettings();
  @Input() msTexts = DropdownOptions.getMsTexts();

  @Input() options = [];
  @Input() selectedValues: Array<any>;
  @Output() selectionChanged: EventEmitter<any> = new EventEmitter();
  @Input() fixedTitle: string;
  @Input() showCheckAll: boolean = true;

  optionsModel: number[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: any) {
    if (changes.selectedValues && changes.selectedValues.currentValue) {
      let optionsModel = this.selectedValues.map(item => {
        return parseInt(item.id);
      })

      //update model only if the value has been changed
      if (JSON.stringify(this.optionsModel.sort()) !== JSON.stringify(optionsModel.sort())) {
        this.optionsModel = optionsModel;
      }
    }
    if (changes.fixedTitle && changes.fixedTitle.currentValue) {
      this.msSettings.fixedTitle = true;
      this.msTexts.defaultTitle = this.fixedTitle;
    }
    if (changes.showCheckAll) {
      this.msSettings.showCheckAll = this.showCheckAll;
      this.msSettings.showUncheckAll = this.showCheckAll;
    }
  }

  valueChanged(eventData: any) {
    this.optionsModel = eventData;
    let data = this.optionsModel.map(item => {
      return {id: item};
    });
    this.selectionChanged.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/multiselect-dropdown/multiselect-dropdown.component.ts